module.exports = __webpack_public_path__ + "img/TRAXI_LOGOTIPO_01.35c8bcde.png";